<template>
  <div class="home">12121212</div>
</template>
<script>
export default {
  name: 'HomePage',
  components: {},
  data() {
    return {
      form: {
        accountNo: '',
        password: '',
        mobile: '',
        code: undefined,
        validCodeReqNo: '',
        uuid: '',
        rememberMe: false,
      },
    }
  },
  watch: {},
  created() {
    console.log(11111, '顶顶顶顶')
    // console.log(defaultSettings,'defaultSettingsdefaultSettings');
  },
  methods: {},
}
</script>
<style lang="less" scoped>
.home {
  background: red;
  width: 100%;
  height: 100vh;
}
</style>